import React from 'react'
import { tdProps } from './helpersProps'

const NewsletterSectionSpacer = ({paddingTop}) => (
    <tr>
        <td style={{paddingTop: paddingTop}} {...tdProps}></td>
    </tr>
)

export default NewsletterSectionSpacer